import {
  Alert,
  Autocomplete,
  Button,
  CircularProgress,
  FormControl,
  FormGroup,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { fieldTypeOptionsArray } from "../../../constants/constantList";
import { useDispatch, useSelector } from "react-redux";
import { api, useGetPdcListQuery, useGetSchemaListQuery } from "../../../redux/api";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep, debounce, has, isArray, isEmpty, isEqual } from "lodash";
import { treeActions } from "../../../redux/slices/treeSlice";
import { getNewRecordName } from "../../RightContextMenu/ContextActions/NewRecord";
import { genericRules, validateOnFlow, validateRevertTime, validationTime } from "../../../utils/validate";
import { isDuplicateName } from "./RecordPropertyForm";
import { lgDocPath } from "../../../constants/languageDocPaths";
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LabeledCheckbox from "../../TemplateProperties/TPCheckbox";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DynamicClauseContextMenu from "../../ContextMenu/DynamicClauseContextMenu";
import Tree from "rc-tree";
import DatePattern from "../PatternModal/DatePattern";
import ErrorModal from "./FieldDataValidation/ErrorModal";
import NumberFormatter from "../PatternModal/NumberFormatter";
import WorkflowSessionModal1 from "../WorkflowSessionModal1";
import DatabaseNavigator from "./DataTypeComponents/DatabaseNavigator"
import Repository from "../../Repository/Repository";
import SchemaModal from "./DataTypeComponents/SchemaModal";
import LoadingScreen from "/src/components/LoadingScreen";
import { SYSTEM_SOURCE_NAME } from "../../../constants/loopRecordOptions";
import LightTooltip from "../../../commonComponents/LightTooltip";
import { getSelectedNodes } from "../../RightContextMenu/ContextActions/CopyAndPaste";
import { FIELD_TYPE } from "../../../constants/datatypes";

const validationRules = {
  TITLE: genericRules.noSlashRule,
  LBL_START_POSITION: genericRules.numericRule,
  LBL_NUM_OF_CHARS: genericRules.numericRule,
  LBL_START_OCCUR: genericRules.numericRule,
  LBL_END_OCCUR: genericRules.numericRule
};

export default function DatabaseForm(props) {
  const { t } = useTranslation();
  const [arg, setArg] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [index, setIndex] = useState(0);
  const [pattern, setPattern] = useState('')
  const [datePattern, setDatePattern] = useState('');
  const [datePatternModal, setDatePatternModal] = useState(false);
  const [queryValue, setQueryValue] = useState("");
  const [error, setError] = useState({});
  const [recordName, setRecordName] = useState("");
  const [connections, setConnections] = useState([]);
  const [numberFormatterModal, setNumberFormatterModal] = useState(false);
  const [argValue, setArgValue] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [dpNetworkCallMessage, setDpNetworkCallMessage] = useState('')
  const [valid, setValid] = useState(true);
  const [flag, setFlag] = useState(false);
  const [workflowSessionModal, setWorkflowSessionModal] = useState(false);
  const [errorType, setErrorType] = useState();
  const [selectedClause, setSelectedClause] = useState([]);
  const [clauseDisable, setClauseDisable] = useState(true);
  const [predefined, setPredefined] = useState("");
  const [required, setRequired] = useState(false);
  const [numberPattern, setNumberPattern] = useState('');
  const [fieldValue, setFieldValue] = useState('');
  const [precision, setPrecision] = useState('');
  const [loadButton, setLoadButton] = useState(false);
  const [enable, setEnable] = useState(false);
  const [pdcModal, setPdcModal] = useState(null);
  const [schema, setSchema] = useState('');
  const errorRef = useRef(new Object());
  const dispatch = useDispatch();
  const { account, user } = useSelector((state) => state.queryParams);
  const pdcRes = useGetPdcListQuery({
    datatype: "database",
    account: account,
    direction: "in",
  });
  const queryParams = useSelector((state) => state.queryParams);
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const translatedData = rightTree.tree[currentTab].translatedData;
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const { PREDEFINED_CONNECTION } = rightTree.tree.templateHeader
  const [pdcInLoading, setPdcInLoading] = useState(true);
  const [connectionOptions, setConnectionOptions] = useState([]);
  const [connection, setConnection] = useState('');
  const [connectionInput, setConnectionInput] = useState('');
  const [columnSorted, setColumnSorted] = useState(false);
  const [connLoading,setConnectionLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [schemaModal,setSchemaModal] = useState(false);
  const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [recordTypeDropDownItems, setRecordTypeDropDownItems] = useState([]);
  const [parentRecords, setParentRecords] = useState([]);
  const [fieldsDropDownItems, setFieldsDropDownItems] = useState([]);
  const pdc = useSelector((state) => state.treeData[parentScreen].pdc);
  const connectionLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SCHEMA_LOADING"]?.isLoading || false) // Commenting this for now
  const tableLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["TABLE_LOADING"]?.isLoading || false) // Commenting this for now
  const isError =  useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SCHEMA_LOADING"]?.isError || false)
  const tableError =  useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["TABLE_LOADING"]?.isError || false)
  const connectedPDC = useSelector(state => state?.treeData?.[parentScreen]?.connectedPDC);
  const listUpdated = useSelector((state) => state.treeData.pdcListUpdated);
  const timerRef = useRef();
  const tableTimerRef = useRef();
  const clickedSchemaButton = useRef();

  const docPaths = {
    DATE: `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/DateFormatter.html`,
    NumberFormatter: `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/NumberFormatter.html`
  };

  const recordTypeOptionArray = [
    { value: "SELECT", text: t("SELECT") },
    { value: "SESSION_DATA", text: t("SESSION_DATA") },
    { value: "SYSTEM_DATA", text: t("SYSTEM_DATA") },
  ];
  

  // const systemDataOptionArray = [
  //   { value: "SELECT", text: t("SELECT") },
  //   { value: "TODAY", text: t("TODAY") },
  //   { value: "TOMORROW", text: t("TOMORROW") },
  //   { value: "YESTERDAY", text: t("YESTERDAY") },
  // ];
  const systemDataOptionArray = SYSTEM_SOURCE_NAME.SYSTEM_DATA
  const systemDataValuesArray = systemDataOptionArray.map(obj => obj.value);
  const systemDataDropDownItems = systemDataOptionArray.map((obj, key) => (
    <MenuItem key={key} value={obj.value === '-- Select --' ? 'SELECT' : obj.value}>
      {obj.title}
    </MenuItem>
  ));

  const fieldTypeDropDownItems = fieldTypeOptionsArray.map((obj, key) => (
    <MenuItem key={key} value={obj.value}>
      {t(obj.text)}
    </MenuItem>
  ));

  const fieldOption = [
    t('EMPTY_COMBO'),
  ]
  const fieldDropDowns = fieldOption.map(ele => { return { label: ele } })

  const getUnderConstruction = () => {
    alert("Under Constrution");
  };

  const handleClose = () => {
    setOpenDrawer(false);
  }

  const handleLoading  = (value) => {
    if (value) setConnectionLoading(true);
    else setTimeout(() => setConnectionLoading(false), 500)
  }

  const updateHandler = (key, val) => {
    if (key !== "TYPE" &&
      key !== "PREDEFINED" &&
      key !== "ROOT_RECORD_TYPE" &&
      key !== "ARG" &&
      key !== "CONNECTION" &&
      key !== "SCHEMA" &&
      key !== "SORT_DB_COLUMNS" &&
      key !== "VALUE") return;

    let newSelectedNode = cloneDeep(selectedNode);
    const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
      if (objValue?.key !== selectedNode.key) {
        return;
      }

      if (key === 'TYPE') {
        objValue.title = val;
        objValue[key] = val;
      }
      else if (key === "ARG" || key === "VALUE") {
        const clauseArray = objValue?.CLAUSE?.length ? objValue?.CLAUSE[0] : {}
        objValue.CLAUSE = [
          {
            ...clauseArray,
            TYPE: clauseArray?.TYPE || 'WHERE',   // Match SWT: Clause(Constants.WHERE, value)
            ARG: clauseArray?.ARG ?? [],          // Match SWT: ensure ARG is always array
            [key]: key === 'VALUE' ? (val) : val
          }
        ]
      }
      else if (key === "PREDEFINED"){
        setSchema('');
        if ((val?.trim() === "" || val === "" || val === null || val === undefined)) {
          delete objValue.PREDEFINED;
          delete objValue.SCHEMA;
        }else {
          objValue[key] = val;
          objValue['SCHEMA'] = ''
        }
      }
      else {
        objValue[key] = val;
      }

      newSelectedNode = objValue;

      if (isArray(objValue?.children)) {
        return objValue.children;
      }
    });

    //prevent unnecessary dispatch
    if (isEqual(translatedData, updatedData)) return;

    dispatch(treeActions.setRightTreeSelectedNode({
      screen: parentScreen,
      type: rightTree?.currentTab,
      data: newSelectedNode
    }));

    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  };


  const argArrayUpdateHandler = (name, val) => {
    const value = val;
    const newArgArray = cloneDeep(arg);
    if (name === "RECORD_TYPE") {
      newArgArray[index] = {
        ...newArgArray[index],
        [name]: value,
        MAPNAME: ''
      }
    }
    else if (name === "ARGNAME") {
      newArgArray[index] = {
        ...newArgArray[index],
        [name]: value ? ("%" + value + "%") : ''
      }
    } else {
      newArgArray[index] = {
        ...newArgArray[index],
        [name]: value
      }
    }
    setArg(newArgArray);
    debounceChangeHandler("ARG", newArgArray);
    clauseToRCTree(newArgArray);
  }


  const debounceChangeHandler = useCallback(debounce(updateHandler, 800), [
    rightTree.currentTab,
    rightTree.tree,
  ]);

  // Blur Handler

  const argNameHandler = () => {
    if (!argValue) {
      setArgValue('UNNAMED');
      argArrayUpdateHandler('ARGNAME', 'UNNAMED');
      setErrorModal(true);
      setErrorMessage(t('BOX_ENTER_A_NAME_FOR_THE_DYNAMIC_CLAUSE_VALUE'));
      setErrorType();
    }
  }

  const recordNameValidation = (event) => {
    const { value, name } = event.target;
    const isDuplicate = isDuplicateName(rightTree.tree, value, selectedNode);
    setError((previous) => {
      let copyPrevious = JSON.parse(JSON.stringify(previous));
      if (isDuplicate) copyPrevious[name] = `${value} ${t('_ERR_ALREADY_EXISTS')}`;
      else {
        delete copyPrevious?.[name];
      }
      return copyPrevious;
    })

    if (isDuplicate) {
      if (errorRef?.current?.[name]) clearTimeout(errorRef?.current[name]);
      const timerId = setTimeout(() => {
        setError((prev) => {
          const copyPrev = JSON.parse(JSON.stringify(prev));
          delete copyPrev[name];
          return copyPrev;
        })
      }, validationTime)
      errorRef.current = { ...errorRef.current, [name]: timerId }
    }

    const finalValue = (!isDuplicate && value) ? value : getNewRecordName(rightTree.tree);// To Get Record Name in Sequence wise.
    setRecordName(finalValue);
    debounceChangeHandler('TYPE', finalValue);
    event.stopPropagation();
  }

  const valueHandler = ([valueObj]) => {
    const newArgArray = cloneDeep(arg);
    const WF_ITEM_WFKEY = valueObj?.account + "/" + valueObj?.template + "/" + valueObj?.workflowGroup
    newArgArray[index] = {
      ...newArgArray[index],
      MAPNAME: valueObj?.MAPNAME,
      WF_ITEM_WFKEY: WF_ITEM_WFKEY,
      WF_ITEM_LOCATION: valueObj?.WF_ITEM_LOCATION,
      WF_ITEM_ID: valueObj?.WF_ITEM_ID,
    }
    setFieldValue(valueObj?.MAPNAME || '');
    setArg(newArgArray);
    debounceChangeHandler("ARG", newArgArray);
    clauseToRCTree(newArgArray);
  }


  // RC TREE FUNCTIONS

  const clauseToRCTree = (data) => {
    const treeData = data?.map((ele, idx) => {

      const isPercentageSign = ele?.ARGNAME[0] === '%' && ele?.ARGNAME[ele?.ARGNAME?.length - 1] === '%'

      return {
        key: `cl-${idx}`,
        title: isPercentageSign ? ele?.ARGNAME : `%${ele?.ARGNAME}%`,
        ICON_DISPLAY: 'QUERY'
      }
    })
    setTreeData(treeData);
  }

  const iconRender = (node) => {
    return <span className={"tree-icon " + node.ICON_DISPLAY}></span>;
  }

  const onSelect = (keys, data) => {
    setSelectedClause([data.node.key]);
  }
  const onRightClick = (data) => {
    setSelectedClause([data.node.key]);
  }

  // Pattern Modal Handler Functions

  const testDateHandler = (key, val) => {
    if (!val && key === 'fromModal') {
      setDpNetworkCallMessage(t('BOX_NO_FORMAT_WAS_SPECIFIED__SEL_CANCEL_TO_CLS_DIALOG_AND_RET_TO_MAIN_SCREEN'))
      setValid(false)
    }
    if (!val && key !== 'fromModal') {
      setPattern(val);
      argArrayUpdateHandler("PATTERN", val)
      return;
    }
    setLoading(true);
    dispatch(
      api.endpoints.validateDatePattern.initiate({
        datePattern: val,
      })
    ).then((response) => {
      if (response) {
        if (response.data.current_state === 'ERROR') {
          setValid(false)
          setFlag(false)
          setDpNetworkCallMessage(response.data.message)

        } else {
          if (key === 'fromField') argArrayUpdateHandler('PATTERN', val)
          if (key === 'fromModal') {
            setFlag(true)
            setDpNetworkCallMessage(response.data.message)
          }
          setValid(true)
        }

      }
    })
    .finally(() => {
      setLoading(false);
    })


  };

  const datePatternModalOkHandler = () => {
    if (flag) {
      setPattern(datePattern);
      argArrayUpdateHandler("PATTERN", datePattern);
    }
    setDatePatternModal(!datePatternModal);
  };

  const datePatternModalCancelHandler = () => {
    setDatePatternModal(!datePatternModal);
  };


  const numberFormatterOkHandler = (valuesObj) => {
    const newArgArray = cloneDeep(arg);
    newArgArray[index] = {
      ...newArgArray[index],
      ...valuesObj
    }
    setArg(newArgArray);
    debounceChangeHandler("ARG", newArgArray);
    clauseToRCTree(newArgArray);
    setPattern(valuesObj?.PATTERN);
    setNumberFormatterModal(false);

  }

  const recordNameChange = (event) => {
    const previousValue = recordName;
    const { name, value } = event.target;
    setRecordName(prev => event.target.value);
    const errorState = validateOnFlow(name, value, validationRules);
    const isEmptyObj = isEmpty(errorState);
    
    if (isEmptyObj) debounceChangeHandler('TYPE', value);

    setError((previous) => {
      let copyPrevious = JSON.parse(JSON.stringify(previous));
      if (isEmptyObj)
        delete copyPrevious?.[event.target.name]
      else {
        copyPrevious = {
          ...copyPrevious,
          ...errorState
        }
      }
      return copyPrevious;
    })

    if (!isEmpty(errorState)) {
      setTimeout(() => {
        setRecordName((prev) => {
          let val = prev;
          val = val.replaceAll('/', '');
          return val;
        })
      }, validateRevertTime)

      if (errorRef?.current?.[name]) clearTimeout(errorRef?.current[name]);
      const timerId = setTimeout(() => {
        setError((prev) => {
          const copyPrev = JSON.parse(JSON.stringify(prev));
          delete copyPrev[name];
          return copyPrev;
        })
      }, validationTime)
      errorRef.current = { ...errorRef.current, [name]: timerId }
      return;

    }
  }

  const connectToDatabaseHandler = () => {
    
    setSchema('');
    if (timerRef.current) clearTimeout(timerRef.current);
    dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isLoading: true, isError: false}}));
    dispatch(api.endpoints.connect_to_selected_db.initiate({
      account: account,
      user: user,
      direction: parentScreen === 'inbound' ? 'IN' : 'OUT',
      pdc_name: connection
    },{forceRefetch : true}))
    .then(res => {
      if (['success', 'connected'].includes(res?.data?.message?.trim()?.toLowerCase())) {
          setShowAlert({ mssg: res?.data?.data?.toUpperCase() || res?.data?.message?.toUpperCase(), isOpen: true, type: 'success' })
          const schemas = Object.keys(pdc?.[connection] || {});
          
          if (!schemas?.length && connection) {
            dispatch(
              api.endpoints.getSchemaList.initiate(
                {
                  account,
                  direction: parentScreen === "inbound" ? "in" : "out",
                  pdc_name: connection,
                },
                { forceRefetch: true, subscribe : true}
              )
            ).then((res) => {
              if (clickedSchemaButton.current !== selectedNode?.key) return; // it will execute all this for only current record;
              if (res?.data?.current_state === "SUCCESS" && isArray(res?.data?.data)) {
                  if (res?.data?.data?.length === 1) {
                    debounceChangeHandler("SCHEMA", res?.data?.data?.[0]);
                    tablesHandler(res?.data?.data?.[0]);
                    dispatch(treeActions.setConnectedPDC({
                      data : {
                        CONNECTION: connection,
                        SCHEMA: schemas?.[0]
                      }
                    }))
                  }
                  else if (res?.data?.data?.length > 1 && !openDrawer) {
                    setSchemaModal(true); 
                    setSchema(res?.data?.data?.filter(e => e === selectedNode?.SCHEMA)?.length ? selectedNode?.SCHEMA : '');
                  }
                  handleLoading(false);
                  setLoadButton(true);
                  setEnable(true);
                  setColumnSorted(true);
              }
              else {
                const message = !isArray(res?.data?.data) ? res?.data?.data : res?.data?.message;
                setShowAlert({ mssg: message, isOpen: true, type: 'warning' })
              }
            })
          }
          else if (schemas?.length && connection){
            if (schemas?.length === 1) {
              debounceChangeHandler("SCHEMA", schemas?.[0]);
              tablesHandler(schemas?.[0]);
              dispatch(treeActions.setConnectedPDC({
                data : {
                  CONNECTION: connection,
                  SCHEMA: schemas?.[0]
                }
              }))
            }
            else if (schemas?.length > 1) {
              setSchemaModal(true);
              setSchema(schemas?.filter(e => e === selectedNode?.SCHEMA)?.length ? selectedNode?.SCHEMA : '');
            } 
            dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isLoading: false, isError: false}}));
            handleLoading(false);
            setLoadButton(true);
            setEnable(true);
            setColumnSorted(true);
        }
        
      } else {
        setShowAlert({ mssg: res?.data?.data || res?.data?.message || t("BOX_UNABLE_TO_CONNECT_CHECK_DATA_CONNECTION"), isOpen: true, type: 'warning' })
        dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isLoading: false, isError: false}}));
      }
    })
    //timed fallback incase something is wrong with response. will disable the page's Loading state after 25s
    // timerRef.current = setTimeout(() => {
    //     dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isError: true}}));
    // }, 120000)
  }

  const handleAlertClose = () => {
    setShowAlert({...showAlert, isOpen: false});
  }

  const handleChange = (key, value) => {
    const updatePdcConnectionInTemplateHeader = (key, value) => {
      // Check if value is empty and should be deleted
      if (value?.trim() === "" || value === "" || value === null || value === undefined) {
        const updatedHeader = cloneDeep(rightTree.tree.templateHeader);
        delete updatedHeader[key];
        dispatch(treeActions.setRightTreeTemplateHeader({value: updatedHeader, screen: parentScreen}));
      } else {
        const updatedHeader = {
          ...cloneDeep(rightTree.tree.templateHeader),
          [key]: value,
        };
        dispatch(treeActions.setRightTreeTemplateHeader({value: updatedHeader, screen: parentScreen}));
      }
    };
    if (value !== connection){
      setLoadButton(false);
      debounceChangeHandler(key,value);
      if (selectedNode?.[key] !== value) updatePdcConnectionInTemplateHeader("PREDEFINED_CONNECTION",value);
    }
  }

  const toggle = () => {
    setPdcModal(null);
  }

  const setRecordNameDropDown = () => {
    let ParentNodes = [];
    let tempKey = "";
    selectedNode?.key?.split("-")?.forEach((e, i) => {
      tempKey = tempKey + e;
      if (i > 0 && tempKey !== selectedNode?.key && tempKey !== "ib-0") {
        ParentNodes.push(getSelectedNodes([tempKey], translatedData)[0]);
      }
      tempKey = tempKey + "-";
    })
    setParentRecords(ParentNodes);
    ParentNodes = ParentNodes.map(e => {
      return {value: e.TYPE, text: e.TYPE}
    })
    setRecordTypeDropDownItems([...recordTypeOptionArray, ...ParentNodes].map((obj, key) => (
      <MenuItem key={key} value={obj.value}>
        {t(obj.text)}
      </MenuItem>
    )))
  }
  
  const setFieldsDropDowns = (recordName) => {
    if("SELECT" || recordName === "SESSION_DATA" || recordName === "SYSTEM_DATA" || !recordName) setFieldsDropDownItems([{label: t("EMPTY_COMBO")}]);
    setFieldsDropDownItems(
      [{MAPNAME: t("SELECT")}, ...(parentRecords.filter(e => e.TYPE === recordName)?.[0]?.children || [])
      ?.filter(e => FIELD_TYPE[e.ICON_DISPLAY])]
      ?.map((e, key) => {
        return { label: e?.MAPNAME }
      }) || []
    )
  }

  const getConnections = () => {
    dispatch(api.endpoints.getAllPdcDetail.initiate({
        account: account,
        direction: 'in'
    }, {forceRefetch: true})).then(res => {
        if (res?.data?.current_state === 'ERROR' || !res?.data?.predefined_connections) {
            console.log(res?.data?.current_state);
        } else {
            const list = [];
            for (const [key, value] of Object.entries(res?.data?.predefined_connections)) {
                if (Object.values(value)[0]?.DATABASE_TYPE !== undefined)
                    list.push(Object.keys(value)[0]);
            }
            setConnectionOptions( [{label: t('SELECT')},...list.map((e, i) => {return { label: e}})]);
        }
    })
  }

  useEffect(() => {
    if (isError && connectionLoading) {
      setShowAlert({ mssg: t('BOX_MSG_GENERAL_ERROR'), isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isLoading: false, isError: false}}));
      setEnable(false);
      setLoadButton(false);
    }
    if (tableError && tableLoading) {
      setShowAlert({ mssg: t('BOX_MSG_GENERAL_ERROR'), isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "TABLE_LOADING", data: {isLoading: false, isError: false}}));
    }
  },[isError, tableError])

  useEffect(() => {
    getConnections();
    clickedSchemaButton.current = selectedNode?.key
    setConnectionLoading(false);
    let queryValue = selectedNode?.CLAUSE?.length && selectedNode?.CLAUSE[0]?.VALUE || '';
    queryValue = queryValue === t("MSG_DATABASE_WHERE_CLAUSE") ? '' : queryValue;
    let argArray = selectedNode?.CLAUSE?.length ? selectedNode?.CLAUSE[0]?.ARG : [];
    // Normalize: ensure every ARGNAME is wrapped with %; persist to Redux if any were updated
    if (isArray(argArray) && argArray.length > 0) {
      const normalizedArgArray = argArray.map((item) => {
        const name = item?.ARGNAME;
        if (name == null || name === '') return item;
        const hasWrapper = name?.length >= 2 && name?.[0] === '%' && name?.[name?.length - 1] === '%';
        if (hasWrapper) return item;
        const raw = name?.replace(/^%*/, '').replace(/%*$/, '');
        return { ...item, ARGNAME: raw ? `%${raw}%` : '' };
      });
      const needsUpdate = normalizedArgArray?.some((item, i) => item?.ARGNAME !== argArray?.[i]?.ARGNAME);
      if (needsUpdate) {
        argArray = normalizedArgArray;
        updateHandler("ARG", normalizedArgArray);
      }
    }
    setRecordName(selectedNode?.TYPE || "");
    setQueryValue((queryValue))
    setRequired(selectedNode?.ROOT_RECORD_TYPE || false);
    setArg(argArray);
    setColumnSorted(selectedNode?.SORT_DB_COLUMNS || false);

    // When there is no PREDEFINED value, remove PREDEFINED (and SCHEMA) from the node in Redux
    if (selectedNode?.hasOwnProperty('PREDEFINED') && selectedNode?.PREDEFINED?.trim() === "") {
      updateHandler('PREDEFINED', '');
      setConnection('');
    }else setConnection(selectedNode?.PREDEFINED || '');

    clauseToRCTree(argArray);
    if (queryValue) setClauseDisable(false);
    else setClauseDisable(true);
    if (argArray?.length) setSelectedClause(['cl-0']);
    else setSelectedClause([]);
    setDpNetworkCallMessage("");

    if (connectedPDC.CONNECTION === selectedNode?.PREDEFINED) {
      const schemas = Object.keys(pdc?.[selectedNode?.CONNECTION] || {});
      handleLoading(false);
      setLoadButton(true);
      setEnable(true);
      setColumnSorted(true);
      const selectedSchema = schemas.includes(selectedNode?.SCHEMA) ? selectedNode?.SCHEMA :selectedNode?.CONNECTION === connectedPDC?.CONNECTION ? schemas.includes(connectedPDC?.SCHEMA)? connectedPDC?.SCHEMA : schemas?.[0] || '' : schemas?.[0];
      setSchema(selectedSchema);
      // console.log(selectedSchema, selectedNode?.SCHEMA);
    }

    setRecordNameDropDown()

    return () => {
      setLoadButton(false);
      setEnable(false);
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isLoading: false, isError: false}}));
    }
  }, [selectedNode?.key]);


  useEffect(() => {
    const index = selectedClause[0]?.split('-')[1] || 0;
    const argName = arg?.length ? (arg[index]?.ARGNAME || '') : ''
    const isPercentageSign = argName[0] === '%' && argName[argName?.length - 1] === '%'

    setIndex(index);
    setArgValue(isPercentageSign ? argName?.substring(1, arg[index]?.ARGNAME?.length - 1) : argName);
    setPattern(arg?.length ? (arg[index]?.PATTERN || '') : '');
    setFieldsDropDowns(arg?.[index]?.RECORD_TYPE);
    setFieldValue(arg?.[index]?.MAPNAME || "")
  }, [selectedClause])

  useEffect(() => {
    setDpNetworkCallMessage("");
  }, [index, datePatternModal])

  useEffect(() => {
    if (listUpdated) getConnections();
    return () => { dispatch(treeActions.setPdcListUpdated({ status: false })); };
}, [listUpdated, dispatch]);

  const tablesHandler = (schema) => {
    if (tableTimerRef.current) clearTimeout(tableTimerRef.current);
    const tables = Object.keys(pdc?.[connection]?.[schema] || {});
    if (!tables?.length && connection && schema) {
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "TABLE_LOADING", data: {isLoading: true, isError: false}}));
      dispatch(
        api.endpoints.get_database_table_info.initiate(
          {
            account,
            user,
            direction: parentScreen === "inbound" ? "IN" : "OUT",
            pdc_name: connection,
            schema_name: schema,
          },
          { forceRefetch: true }
        )
      ).then( res => {
        // console.log(res);
        if (res?.data?.current_state === "SUCCESS" && isArray(res?.data?.data?.database_table_list)){
        }else {
          const message = res?.data?.message;
          // console.log(message)
          setShowAlert({ mssg: message, isOpen: true, type: 'warning' })
        }
      })
    }
    // tableTimerRef.current = setTimeout(() => {
    //   dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "TABLE_LOADING", data: {isError: true}}));
    // }, 25000)
  }


  // useEffect(() => {
  //   if (connectedToDB) {
  //     
  //   } else {
  //     dispatch(treeActions.setConnectedDbTableList({
  //       screen: parentScreen,
  //       value: []
  //     }))
  //   }

  // }, [connectedToDB])



  return (
    <>
      <Stack spacing={"8px"} className="tp-segment">
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            autoComplete="off"
            type="text"
            className={"width-100"}
            label={t("LBL_REC_NAME")}
            name={"TITLE"}
            value={recordName || ''}
            onChange={recordNameChange}
            {...(has(error, "TITLE")
              ? {
                helperText: error["TITLE"],
                error: true,
              }
              : {
                helperText: "",
                error: false,
              })}
            onBlur={recordNameValidation}
          />
        </FormControl>
        <div className="flex width-100" style={{flexWrap: "wrap", gap: "4px"}}>
          <Autocomplete
            size="small"
            variant="outlined"
            sx={{flexGrow: 2, minWidth: "140px", marginTop: "8px"}}
            disabled={connectionLoading}
            loading={pdcInLoading}
            options={connectionOptions}
            value={connection}
            inputValue={connection}
            onChange={(event, newValue) => {
              handleChange('PREDEFINED', newValue?.label || '')
              setConnection(newValue?.label || '');
              setEnable(false);
            }}
            onInputChange={(event, newInputValue) => {
              handleChange('PREDEFINED', newInputValue)
              setConnection(newInputValue);
              if (newInputValue === '') setLoadButton(true)
              setEnable(false);
            }}
            renderInput={(params) => !enable ? <TextField size="small" variant="outlined" {...params} label={t("DATA_CONN_OVERRIDE")} />
              : <TextField size="small" variant="outlined" {...params} label={t("DATA_CONN_OVERRIDE")}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <span  style={{fontSize: '15px', color: 'green'}}>
                      {enable && !connectionLoading && connection && connection !== t('SELECT') && <span className="CHECK_CIRCLE"></span>}
                    </span>
                  )
                }} />
            }
          />

          <LightTooltip title={t('LBL_PDC_BTN')}>
            <Button
              variant="outlined"
              size="small"
              disableElevation
              sx={{
                width: '40px',
                padding: '4px 8px',
                minWidth: '40px',
                marginTop: "8px",
              }}
              onClick={() => setPdcModal(5)}
            >
              <span className="FLOWSHEET"></span>
            </Button>
          </LightTooltip>
          <Button
            style={{minWidth: '200px', width: "200px", marginTop: "8px"}}
            variant="outlined"
            size="small"
            disableElevation
            disabled={connectionLoading || loadButton || enable || !connection || connection === t('SELECT')}
            className='width-100'
            onClick={() => connectToDatabaseHandler()}
          >
            {connectionLoading && !enable ? <CircularProgress size={"16px"} /> : !enable && t('LOAD_DATABASE_SCHEMA')}
            {!connectionLoading && enable && t('SUCCESFULLY_LOADED_SCHEMA')}
          </Button>
        </div>
        <div style={{marginTop: '8px'}}>
            <LabeledCheckbox
                checked={columnSorted}
                handleCheck={(checked) => { 
                  setColumnSorted(checked) 
                  debounceChangeHandler('SORT_DB_COLUMNS', checked)
                }}
                label={t("BTN_SORT_DB_COLUMNS")}
            />
          </div>
        {selectedNode?.key?.split('-')?.length === 3 && <FormControl sx={{marginTop: '8px !important'}}>
          <LabeledCheckbox
            
            checked={required}
            handleCheck={() => {
              debounceChangeHandler('ROOT_RECORD_TYPE', !required);
              setRequired(!required);
            }}
            label={t("LBL_MAKE_ROOT_QUERY")}
          />
        </FormControl>}
        <Button
          size="small"
          variant="outlined"
          className="bttn-database-navigator"
          onClick={() => setOpenDrawer(true)}
          disabled={connectionLoading}
        >
          <span style={{opacity: connectionLoading ? '0.6' : '1' }}  className="DATABASE"></span>
          <span style={{opacity: connectionLoading ? '0.6' : '0.8' }}> {t("DB_NAV_BUTTON")} </span>
        </Button>
        <FormControl
          className="width-100"
          size="small"
          sx={{ marginTop: "1rem" }}
        >
          <TextField
            multiline={true}
            rows={10}
            sx={{ whiteSpace: "nowrap !important" }}
            className="query-textarea"
            size="medium"
            type="text"
            value={queryValue}
            placeholder={t("MSG_DATABASE_WHERE_CLAUSE")}
            onChange={(e) => {
              const value = e.target.value;
              if (value) setClauseDisable(false);
              else setClauseDisable(true);
              setQueryValue(value);
              debounceChangeHandler("VALUE", value);
            }}
          />
        </FormControl>

        <FormControl className="width-100" size="small">
          <FormLabel>{t("LBL_DYNAMIC_WHERE_CLAUSE_VALUES")}</FormLabel>
          <div className="div-textbox" id="dynamicClause" style={{ userSelect: "none" }}>
            <Tree
              selectedKeys={selectedClause}
              treeData={treeData}
              selectable={true}
              icon={iconRender}
              onSelect={onSelect}
              onRightClick={onRightClick}
            />
          </div>
          <DynamicClauseContextMenu
            selectedClause={selectedClause}
            arg={arg}
            treeUpdate={clauseToRCTree}
            setSelectedClause={setSelectedClause}
            updateFunction={debounceChangeHandler}
            setArg={setArg}
            clauseDisable={clauseDisable}
          />
        </FormControl>

        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            autoComplete="off"
            type="text"
            disabled={!selectedClause.length}
            value={argValue || ''}
            className={"width-100"}
            label={t("LBL_NAME")}
            name={""}
            onChange={(e) => {
              setArgValue(e.target.value);
              argArrayUpdateHandler("ARGNAME", e.target.value);
            }}
            onBlur={argNameHandler}
          />
        </FormControl>

        <FormControl variant="outlined" className="width-100" size="small">
          <InputLabel id="fieldTypeDD">{t("LBL_FIELD_TYPE")}</InputLabel>
          <Select
            className={"width-100"}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                },
              },
            }}
            disabled={!selectedClause.length}
            name={""}
            value={arg?.length ? arg[index]?.FIELDTYPE || '' : ''}
            labelId="fieldTypeDD"
            label={t("LBL_FIELD_TYPE")}
            id="fieldTypeDD"
            onChange={(e) => {
              argArrayUpdateHandler("FIELDTYPE", e.target.value);
            }}
          >
            {fieldTypeDropDownItems}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className="width-100" size="small">
          <InputLabel id="recordNameDD">{t("LBL_REC_NAME")}</InputLabel>
          <Select
            className={"width-100"}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                },
              },
            }}
            name={""}
            disabled={!selectedClause.length}
            value={arg?.length ? arg[index]?.RECORD_TYPE || "SELECT" : ''}
            labelId="recordNameDD"
            label={t("LBL_REC_NAME")}
            id="recordNameDD"
            onChange={(e) => {
              if (e.target.value === 'SELECT') {
                argArrayUpdateHandler("RECORD_TYPE", '');
              } else {
                argArrayUpdateHandler("RECORD_TYPE", e.target.value);
              }
              setFieldsDropDowns(e.target.value);
            }}
          >
            {recordTypeDropDownItems}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className="width-100" size="small">
          <div className="flex">
            {(arg?.length && arg[index]?.RECORD_TYPE === 'SYSTEM_DATA') ?
              <>
                <InputLabel id="fieldNameDD">{t("LBL_FLD_NAME")}</InputLabel>
                <Select
                  className={"width-100"}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                      },
                    },
                  }}
                  name={""}
                  value={!systemDataValuesArray.includes(arg[index]?.MAPNAME) ? "SELECT" : arg[index]?.MAPNAME}
                  disabled={!selectedClause.length}
                  labelId="fieldNameDD"
                  label={t("LBL_FLD_NAME")}
                  id="fieldNameDD"
                  onChange={(e) => {
                    if (e.target.value === 'SELECT') {
                      argArrayUpdateHandler("MAPNAME", '');
                    } else {
                      argArrayUpdateHandler("MAPNAME", e.target.value);
                    }
                  }}
                >
                  {systemDataDropDownItems}
                </Select>
              </> :
              <FormControl className="width-100" size="small">
                <Autocomplete
                  size="small"
                  variant="outlined"
                  className='width-100'
                  disabled={!selectedClause?.length || arg[index]?.RECORD_TYPE === 'SYSTEM_DATA' || recordName === "SELECT"}
                  freeSolo
                  autoSelect
                  options={["SYSTEM_DATA", "SELECT"].includes(recordName)  ? fieldDropDowns : fieldsDropDownItems}
                  value={fieldValue}
                  inputValue={fieldValue}
                  onChange={(event, newValue) => {
                    argArrayUpdateHandler('MAPNAME', newValue?.label || '')
                    setFieldValue(newValue?.label || '');
                  }}
                  onInputChange={(event, newInputValue) => {
                    setFieldValue(newInputValue);
                    argArrayUpdateHandler('MAPNAME', newInputValue || '')
                  }}
                  renderInput={(params) => <TextField size="small" variant="outlined" {...params} label={t("LBL_FLD_NAME")} />}
                />
              </FormControl>}

            <Button
              variant="outlined"
              size="small"
              disableElevation
              disabled={!arg?.length || arg[index]?.RECORD_TYPE !== 'SESSION_DATA'}
              className="margin-left-4"
              sx={{
                width: "40px",
                padding: "4px 8px",
                minWidth: "40px",
              }}
              onClick={() => setWorkflowSessionModal(true)}
            >
              <MoreHorizIcon fontSize="small" />
            </Button>
          </div>
        </FormControl>
        
        <FormControl className="width-100" size="small">
          <div className="flex">
            <TextField
              variant="outlined"
              size="small"
              autoComplete="off"
              type="text"
              disabled={!arg?.length || (!selectedClause.length || arg[index]?.FIELDTYPE === 'ALPHA') || !["TODAY", "TOMORROW", "YESTERDAY"].includes(arg[index]?.MAPNAME)}
              className={"width-100"}
              label={t("LBL_PATTERN")}
              name={""}
              value={pattern}
              error={!valid}
              onChange={(e) => {
                setPattern(e.target.value);
                if (arg[index]?.FIELDTYPE === 'DATE') {
                  setDpNetworkCallMessage('');
                  setFlag(false)
                  setValid(true)
                } else {
                  argArrayUpdateHandler("PATTERN", e.target.value);
                }
              }}
              onBlur={() => {
                if (arg[index]?.FIELDTYPE === 'DATE') {
                  testDateHandler("fromField", pattern);
                }
              }}
            />
            <Button
              variant="outlined"
              size="small"
              disabled={!arg?.length || (!selectedClause.length || arg[index]?.FIELDTYPE === 'ALPHA')}
              disableElevation
              className="margin-left-4"
              sx={{
                width: "40px",
                padding: "4px 8px",
                minWidth: "40px",
              }}
              onClick={() => {
                if (arg[index]?.FIELDTYPE === 'DATE') {
                  setDatePatternModal(true);
                  setDatePattern(pattern);
                }
                else if (['FLOAT', 'INTEGER'].includes(arg[index]?.FIELDTYPE)) {
                  setNumberFormatterModal(true);
                  setNumberPattern(pattern);
                }
              }}
            >
              {(arg?.length && ['FLOAT', 'INTEGER'].includes(arg[index]?.FIELDTYPE)) ? <CalculateOutlinedIcon fontSize="medium" /> :
                (arg?.length && ['DATE'].includes(arg[index]?.FIELDTYPE)) ? <CalendarMonthOutlinedIcon fontSize="medium" /> : <MoreHorizIcon fontSize="small" />}
            </Button>
          </div>
          <p className="error" style={{ fontSize: '12px', margin: '10px' }}>{dpNetworkCallMessage}</p>
        </FormControl>
      </Stack>
      <DatePattern
        openModal={datePatternModal}
        docPath={docPaths.DATE}
        okHandler={datePatternModalOkHandler}
        cancelHandler={datePatternModalCancelHandler}
        onChangeHandler={setDatePattern}
        testDateHandler={testDateHandler}
        dpNetworkCallMessage={dpNetworkCallMessage}
        datePattern={datePattern}
        loading={loading}
        valid={valid}
      />
      <NumberFormatter
        openModal={numberFormatterModal}
        docPath={docPaths.NumberFormatter}
        cancelHandler={setNumberFormatterModal}
        okHandler={numberFormatterOkHandler}
        fieldValue={numberPattern}
        precision={precision}
      />
      <ErrorModal
        errorType={errorType}
        errorModal={errorModal}
        errorMessage={errorMessage}
        handleErrorModal={setErrorModal}
      />
      <WorkflowSessionModal1
        sourceType={'callingWorkflow'}
        openModal={workflowSessionModal}
        handleClose={setWorkflowSessionModal}
        valueHandler={valueHandler}
        selection={"single"}
      />
      <DatabaseNavigator 
        setConnectionLoading={handleLoading} 
        showAlert={setShowAlert} 
        alreadyConnected={loadButton && connection !== t('SELECT') && connection} 
        fromCustomDB={false}
        selectedConnection={connection} 
        selectedSchema={schema}
        updateSchema={() => {}}
        updateConnection={() => {}}
        open={openDrawer} 
        handleClose={handleClose}
        sqlQueryToRun={''}
        handleQuery={() => {}}
        setOpenDrawer={() => {}}
        type=''
      />
      <Repository 
        option={pdcModal} 
        setOption={setPdcModal} 
        handleClose={toggle} 
        dir='IN' 
        pdcName={connection}
        onPdcSelect={(selectedPdcData) => {            // Update connection with selected PDC
            if (selectedPdcData.connectionName) {
                setConnection(selectedPdcData.connectionName);
                handleChange('PREDEFINED', selectedPdcData.connectionName);
            }
        }}
      />
      <Snackbar
        open={showAlert.isOpen}
        autoHideDuration={showAlert.type !== "success" ? null : 6000}
        onClose={() => handleAlertClose()}>
        <Alert
          onClose={() => handleAlertClose()}
          severity={showAlert.type}
          variant="filled"
          sx={{ maxWidth: '500px'}}>
          {showAlert.mssg}
        </Alert>
      </Snackbar>
      <SchemaModal 
        schema={schema}
        setSchema={setSchema}
        openModal={schemaModal} 
        handleClose={() =>{
          setSchemaModal(false)
          setLoadButton(false);
          setEnable(false);
        }} 
        okHandler={(val)=>{
          debounceChangeHandler("SCHEMA",val);
          tablesHandler(val);
          setSchemaModal(false);
          dispatch(treeActions.setConnectedPDC({
            data : {
              CONNECTION: connection,
              SCHEMA: val
            }
          }))
        }} 
        connection={connection}
      />
      {/* {connectionLoading ? <LoadingScreen/> : ''} */}
    </>
  );
}
